import _DateTimePicker from './DateTimePicker';

export type { DateTimePickerProps } from './DateTimePicker';
export * from './type';

export const DateTimePicker = _DateTimePicker;
export default DateTimePicker;
